import { render, staticRenderFns } from "./countriesList.vue?vue&type=template&id=0bf97fcc&scoped=true&"
import script from "./countriesList.vue?vue&type=script&lang=js&"
export * from "./countriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf97fcc",
  null
  
)

export default component.exports